// src/lib/kbeanApi/getMyActivity.js
// Filepath: // src/lib/kbeanApi/getMyActivity.js

import { requestJson } from "../http/request";
import { ApiError, UnauthorizedError } from "../http/errors";
import { getAuthToken } from "../storage/authStorage";

/**
 * Calls the "Get My Activity" endpoint.
 * Uses REACT_APP_GET_MY_ACTIVITY as the POST URL.
 *
 * Auth:
 *  - Authorization: Bearer <token> (withAuth: true)
 *  - Header: authResponseData: {"token":"<token>"}  (explicit per requirement)
 */

const DEFAULT_BODY = {
  Sort: "{Created: -1}",
  Page: 0,
  Size: 0,
  GroupBy: "artwork",
  FilterMatureArtworks: false,
  FilterKbeanSelectOnly: false,
  Criteria: [],
  ArtworkIds: [],
};

/**
 * @param {Partial<typeof DEFAULT_BODY>} [overrides]
 * @returns {Promise<any>} Raw JSON activity payload
 */
export async function getMyActivity(overrides = {}) {
  const url = process.env.REACT_APP_GET_MY_ACTIVITY;
  if (!url) {
    throw new ApiError("Missing env REACT_APP_GET_MY_ACTIVITY");
  }

  const body = { ...DEFAULT_BODY, ...overrides };

  // Ensure the companion header mirrors the same token used for Authorization
  const token = getAuthToken();
  if (!token) {
    throw new UnauthorizedError("Missing auth token for activity request", { url });
  }

  return requestJson(url, {
    method: "POST",
    withAuth: true,
    headers: {
      authResponseData: JSON.stringify({ token }),
    },
    body,
    timeoutMs: 15000,
  });
}
